<template>
  <query-filter
    :loading="loading"
    :applyable="validPeriod"
    clearable
    @apply="$emit('submit', params)"
    @clear="$emit('clear')"
  >
    <div class="d-flex align-baseline justify-center">
      <div class="mx-2">{{$t('period')}}</div>
      <div class="mx-2"><month-field v-model="params.from" :data-testid="'event-period-from'" /></div>
      <div class="mx-2">〜</div>
      <div class="mx-2"><month-field v-model="params.to" :data-testid="'event-period-to'" /></div>
    </div>
    <div class="d-flex align-center justify-center">
      <div class="error--text">
        <p class="mt-2 mb-0" v-if="errorMessage">{{errorMessage}}</p>
      </div>
    </div>
  </query-filter>
</template>

<i18n lang="yaml">
ja:
  period: '期間'
  err_period: '指定できる期間は最長3年間（36ヶ月）です'

en:
  period: 'Period'
  err_period: 'You can specify a maximum period of 3 years (36 months)'
</i18n>

<script>
import MonthField from '@/components/molecules/MonthField';
import QueryFilter from '@/components/molecules/QueryFilter';
import { validateEventPeriod } from './validateEventPeriod';

export default {
  name: 'event-period-selector',
  components: {
    MonthField,
    QueryFilter,
  },
  props: {
    initialValue: Object,
    loading: Boolean,
  },
  computed: {
    errorMessage() {
      if (this.validPeriod) {
        return null;
      }
      return this.$t('err_period');
    },
    validPeriod() {
      return validateEventPeriod(this.params.from, this.params.to);
    },
  },
  data() {
    return {
      params: this.initialValue,
    };
  },
};
</script>

<style lang="sass" scoped>
</style>
